// extracted by mini-css-extract-plugin
export default {"mt_10":"ContactUs_mt_10__v2eQB","fs_20":"ContactUs_fs_20__PglIZ","inp":"ContactUs_inp__ujtjj"};